(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_free-shipping-progress"] && !Shopify.designMode) return;
  try {
    class FreeShippingProgress extends HTMLElement {
    static observedAttributes = ['data-progress-scale'];

    #fill;
    #progressAnimation;
    #dialog;
    #dialogObserver;

    connectedCallback() {
      this.#fill = this.querySelector('.free-shipping-progress__fill');

      if (!(this.#fill instanceof HTMLElement)) return;

      const target = this.#getScale(this.dataset.progressScale);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.#setScale(target);
        return;
      }

      this.#dialog = this.closest('dialog');

      if (this.#dialog instanceof HTMLDialogElement) {
        this.#dialogObserver?.disconnect();
        this.#dialogObserver = new MutationObserver(() => this.#handleDialogState());
        this.#dialogObserver.observe(this.#dialog, { attributes: true, attributeFilter: ['open'] });
        this.#handleDialogState();
        return;
      }

      this.#animateScale(0, target, 900);
    }

    disconnectedCallback() {
      this.#dialogObserver?.disconnect();
      this.#progressAnimation?.cancel();
      this.#dialog = undefined;
      this.#dialogObserver = undefined;
      this.#progressAnimation = undefined;
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (!this.isConnected || oldValue === null || oldValue === newValue) return;

      this.#fill = this.querySelector('.free-shipping-progress__fill');

      if (!(this.#fill instanceof HTMLElement)) return;

      const from = this.#getScale(oldValue);
      const to = this.#getScale(newValue);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.#setScale(to);
        return;
      }

      if (this.#dialog instanceof HTMLDialogElement && !this.#dialog.open) {
        this.#setScale(0);
        return;
      }

      this.#animateScale(from, to, 500);
    }

    #getScale(value) {
      return Math.min(1, Math.max(0, Number.parseFloat(value ?? '0') || 0));
    }

    #setScale(value) {
      this.#fill?.style.setProperty('transform', `scaleX(${value})`);
    }

    #handleDialogState() {
      if (!(this.#dialog instanceof HTMLDialogElement)) return;

      if (!this.#dialog.open) {
        this.#progressAnimation?.cancel();
        this.#progressAnimation = undefined;
        this.#setScale(0);
        return;
      }

      this.#animateScale(0, this.#getScale(this.dataset.progressScale), 900, true);
    }

    #animateScale(from, to, duration, restart = false) {
      if (!(this.#fill instanceof HTMLElement)) return;

      const startTransform = this.#progressAnimation && !restart
        ? window.getComputedStyle(this.#fill).transform
        : `scaleX(${from})`;

      this.#progressAnimation?.cancel();

      const animation = this.#fill.animate(
        [{ transform: startTransform }, { transform: `scaleX(${to})` }],
        {
          duration,
          easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
          fill: 'forwards',
        }
      );

      this.#progressAnimation = animation;
      animation.addEventListener(
        'finish',
        () => {
          if (this.#progressAnimation !== animation) return;

          this.#setScale(to);
          animation.cancel();
          this.#progressAnimation = undefined;
        },
        { once: true }
      );
    }
  }

  if (!customElements.get('free-shipping-progress')) {
    customElements.define('free-shipping-progress', FreeShippingProgress);
  }
  } catch(e) { console.error(e); }
})();

})();
